import * as React from 'react';
import {Overlay, SideModal, SideModalContent} from '~/common/layout/Modals';
import Head from '~/common/layout/Head';
import Button from "~/common/elements/mobile/Button";
import {buttonSize, buttonStyle} from "~/common/elements/mobile/consts";
import { getSaleNumber } from "~/apps/pos/helpers";

type Props = {
  sale: any;
  onDelete: any;
  onClose: any;
  features: string[];
}

const SaleDelete = (props: Props) => {
  const { onClose, onDelete, sale, features } = props;

  return (
    <Overlay onClick={onClose}>
      <SideModal>
        <Head headTitle={'Sale delete'} />
        <SideModalContent>
          <div className="confirmation__send">
            <h3 className="confirmation__send__heading">Are you sure you want to delete sale <span className="typ--b">#{getSaleNumber(sale, features)}</span> ?</h3>
            <div className="confirmation__send__buttons">
              <Button
                title='Yes'
                onClick={onDelete}
                buttonStyle={`${buttonStyle.PRIM} ${buttonStyle.WHITE}`}
                buttonSize={buttonSize.LG}
              />
              <Button
                title='No'
                onClick={onClose}
                buttonStyle={`${buttonStyle.PRIM} ${buttonStyle.WHITE}`}
                buttonSize={buttonSize.LG}
              />
            </div>
          </div>
        </SideModalContent>
      </SideModal>
    </Overlay>
  )
}

export default SaleDelete
